const quickLinks = [
  { label: "热榜追踪", href: "#trending" },
  { label: "话题广场", href: "#plaza" },
  { label: "精彩讨论", href: "#feed" },
  { label: "社区公约", href: "#community" },
  { label: "常见问题", href: "#faq" },
];

const boardLinks = [
  "全网评论区",
  "话题广场",
  "讨论版块",
  "灌水区",
  "爆料速递",
  "吃瓜现场",
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-100">
      {/* CTA band */}
      <div className="container-x pt-16 md:pt-20">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-secondary-700 via-secondary-800 to-secondary-950 px-8 py-12 text-center md:px-12 md:py-16">
          <i className="ri-chat-smile-3-line absolute -left-4 -top-4 text-[120px] text-background-50/10"></i>
          <i className="ri-fire-fill absolute -bottom-6 right-0 text-[130px] text-background-50/10"></i>
          <p className="tag-primary mx-auto border border-background-50/20 bg-background-50/10 text-background-50">
            <i className="ri-flashlight-fill"></i> 就差你一个
          </p>
          <h2 className="relative mx-auto mt-4 max-w-2xl text-2xl font-black leading-tight text-background-50 md:text-4xl">
            别一个人吃瓜了，
            <span className="text-accent-300">叫上网友一起聊</span>
          </h2>
          <p className="relative mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-50/85 md:text-base">
            热门事件有新进展、还是只想找个地方轻松唠嗑？来话题广场开一帖，下一秒就有同好接你的梗。
          </p>
          <div className="relative mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <a href="#plaza" className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-base font-bold text-background-50 transition-all hover:-translate-y-0.5 hover:bg-accent-400">
              现在就去开聊 <i className="ri-arrow-right-up-line ml-1"></i>
            </a>
            <a href="#faq" className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-background-50/30 px-7 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-background-50/10">
              先看使用须知
            </a>
          </div>
        </div>
      </div>

      {/* footer body */}
      <div className="container-x grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] md:py-16">
        <div>
          <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜聚集 返回顶部">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-chat-voice-fill text-lg"></i>
            </span>
            <span className="text-lg font-black tracking-tight text-foreground-950">吃瓜聚集⚡</span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
            把评论区、话题广场与讨论版块装进同一个口袋的互动社区。热门事件一起围观，灌水畅聊自在发声。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {[
              ["ri-wechat-line", "微信"],
              ["ri-weibo-line", "微博"],
              ["ri-tiktok-line", "抖音"],
              ["ri-bilibili-line", "B站"],
            ].map(([icon, label]) => (
              <a
                key={label}
                href="#top"
                aria-label={label + " 关注吃瓜聚集"}
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className={icon as string}></i>
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="站内快速导航">
          <h3 className="text-sm font-black text-foreground-950">快速导航</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {quickLinks.map((l) => (
              <li key={l.href + l.label}>
                <a href={l.href} className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700">{l.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="讨论版块导航">
          <h3 className="text-sm font-black text-foreground-950">讨论版块</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {boardLinks.map((b) => (
              <li key={b}>
                <a href="#plaza" className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-secondary-700">{b}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-black text-foreground-950">联系我们</h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            内容反馈、违规举报或商务合作，欢迎来信与我们沟通。
          </p>
          <a
            href="mailto:support@chiguajuji.com"
            className="mt-4 flex items-center gap-2 text-sm font-semibold text-primary-700 hover:underline"
          >
            <i className="ri-mail-send-line"></i> support@chiguajuji.com
          </a>
          <a href="#plaza" className="mt-3 flex items-center gap-2 text-sm text-foreground-600 transition-colors hover:text-primary-700">
            <i className="ri-customer-service-2-line"></i> 在线客服：私信“小瓜”
          </a>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 吃瓜聚集 · 全网网友互动专区 保留所有权利</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-fill text-primary-500"></i>
            理性吃瓜，友善发言
          </p>
        </div>
      </div>
    </footer>
  );
}